import {
  DEMO_CUSTOMER_SEGMENTS,
  type DemoCustomerSegment,
} from '@/lib/fixtures/demo-brand'
import type { Customer, CustomerStatus, JourneyChannel, PurchasedProduct, Touchpoint } from '@/lib/customers/customer-row'

export const FALLBACK_CUSTOMER_SEGMENTS: DemoCustomerSegment[] = DEMO_CUSTOMER_SEGMENTS

const PRODUCT_SETS: PurchasedProduct[][] = [
  [
    { name: 'Spring Promo Bundle', url: null, priceCents: 12900 },
    { name: 'Premium Accessory Kit', url: null, priceCents: 7900 },
  ],
  [{ name: 'Core Product Starter Pack', url: null, priceCents: 8900 }],
  [{ name: 'Limited Drop Hoodie', url: null, priceCents: 6800 }],
  [
    { name: 'Signature Product Set', url: null, priceCents: 15900 },
    { name: 'Replacement Kit', url: null, priceCents: 3900 },
  ],
  [{ name: 'Seasonal Gift Box', url: null, priceCents: 11200 }],
  [
    { name: 'Product Showcase Bundle', url: null, priceCents: 14900 },
    { name: 'Annual Membership', url: null, priceCents: 9900 },
  ],
]

const JOURNEYS: Touchpoint[][] = [
  [
    { channel: 'social', label: 'Meta Ad', day: 12 },
    { channel: 'search', label: 'Google Search', day: 5 },
    { channel: 'tv', label: 'Roku Ad', day: 1 },
  ],
  [
    { channel: 'search', label: 'Google Search', day: 3 },
    { channel: 'email', label: 'Abandoned cart email', day: 0 },
  ],
  [
    { channel: 'tv', label: 'Peacock Ad', day: 8 },
    { channel: 'social', label: 'Instagram Story', day: 2 },
  ],
  [{ channel: 'search', label: 'Google Search', day: 0 }],
  [
    { channel: 'social', label: 'Facebook Ad', day: 18 },
    { channel: 'tv', label: 'Hulu Ad', day: 11 },
    { channel: 'email', label: 'Newsletter', day: 4 },
  ],
  [
    { channel: 'direct', label: 'Direct visit', day: 6 },
    { channel: 'search', label: 'Brand Search', day: 1 },
  ],
]

const CUSTOMER_DETAILS: Array<{
  displayName: string | null
  email: string | null
  phone: string | null
  status: CustomerStatus
}> = [
  { displayName: 'Alex M.', email: 'alex.m@example.com', phone: null, status: 'Repeat customer' },
  { displayName: null, email: null, phone: '+1 (555) 204-1188', status: 'Repeat customer' },
  { displayName: 'Jordan K.', email: 'jordan@example.com', phone: null, status: 'Customer' },
  { displayName: null, email: 'sam.r@example.com', phone: null, status: 'Customer' },
  { displayName: 'Taylor S.', email: 'taylor.s@example.com', phone: '+1 (555) 881-4420', status: 'High value' },
  { displayName: 'Morgan P.', email: 'morgan.p@example.com', phone: null, status: 'Customer' },
]

function sumProducts(products: PurchasedProduct[]) {
  return products.reduce((sum, product) => sum + product.priceCents, 0)
}

function channelsFromJourney(journey: Touchpoint[]): JourneyChannel[] {
  return Array.from(new Set(journey.map((touchpoint) => touchpoint.channel)))
}

export const FALLBACK_CUSTOMERS: Customer[] = Array.from({ length: 50 }, (_, index) => {
  const detail = CUSTOMER_DETAILS[index % CUSTOMER_DETAILS.length]
  const products = PRODUCT_SETS[index % PRODUCT_SETS.length]
  const journey = JOURNEYS[index % JOURNEYS.length]
  const ordersCount = products.length + (index % 7 === 0 ? 1 : 0)
  const totalSpentCents = sumProducts(products) + (ordersCount > products.length ? 4900 : 0)

  return {
    id: `ex-c${index + 1}`,
    anonId: `CUS-${String(10482 + index * 37).padStart(5, '0')}`,
    displayName: index < CUSTOMER_DETAILS.length ? detail.displayName : null,
    email: index < CUSTOMER_DETAILS.length ? detail.email : null,
    phone: index < CUSTOMER_DETAILS.length ? detail.phone : null,
    status: totalSpentCents >= 50000 ? 'High value' : detail.status,
    channels: channelsFromJourney(journey),
    products,
    journey,
    totalSpentCents,
    ordersCount,
    firstSeenDaysAgo: 4 + (index % 28),
  }
})
